import type { PropsWithChildren } from "react";

import type { RichTextPropsContent } from "@ui/eva-components/RichText";
import { RichText } from "@ui/eva-components/RichText";

import { useSavBlocking } from "../../SavBlockingContext";

import styles from "./Disclaimer.module.scss";

type DisclaimerProps = PropsWithChildren<RichTextPropsContent>;

export const Disclaimer = ({ content }: DisclaimerProps) => {
  const { isBlocked } = useSavBlocking();

  if (isBlocked) {
    return null;
  }

  return <RichText isDarkMode={false} content={content} className={styles.disclaimer} dataTestId="disclaimer" />;
};
